import React from 'react';

import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';

const SmoothScrollStyles = createGlobalStyle`
  html.has-smooth-scroll {
    scroll-behavior: smooth;
  }
`;

export default class SmoothScrollLink extends React.PureComponent {
  static propTypes = {
    href: PropTypes.string,
  };

  handleClick = event => {
    if (document) {
      if (!document.documentElement.classList.contains('has-smooth-scroll')) {
        document.documentElement.classList.add('has-smooth-scroll');
      }
      // wait until scrolling is completed before removing class
      window.requestAnimationFrame(() => {
        document.documentElement.classList.remove('has-smooth-scroll');
      });
    }
  };

  render() {
    const { children } = this.props;
    return (
      <>
        {React.cloneElement(children, {
          onClick: this.handleClick, // TODO: test this more
        })}
        <SmoothScrollStyles />
      </>
    );
  }
}
